import isBefore from 'date-fns/isBefore'
import {assocPath, pipe} from 'ramda'

import {
  dateStringToMiddayDate,
  dateToMiddayDate,
  today,
  tomorrow
} from '../utils/date'
import {UserSearchHistoryItem} from './types'

type Value = number | string | boolean | Date

const isExpired = (date: string) =>
  isBefore(dateStringToMiddayDate(date), dateToMiddayDate(new Date()))

const updateSearchParam = (
  param: string,
  value: Value,
  obj: UserSearchHistoryItem
) => assocPath(['searchParams', param], value, obj)

const updateCheckIn = (searchHistoryItem: UserSearchHistoryItem) =>
  updateSearchParam('checkIn', today(), searchHistoryItem)

const updateCheckOut = (searchHistoryItem: UserSearchHistoryItem) =>
  updateSearchParam('checkOut', tomorrow(), searchHistoryItem)

/**
 * Updates expired check-in and check-out dates in the user's search history.
 * If the check-in date is expired, sets check-in to today and check-out to tomorrow.
 * @param searchHistory - Array of user search history items to update.
 * @returns Updated array of user search history items.
 */
export const updateExpiredDates = (searchHistory: UserSearchHistoryItem[]) =>
  searchHistory.map(searchHistoryItem =>
    isExpired(searchHistoryItem.searchParams.checkIn)
      ? pipe(updateCheckIn, updateCheckOut)(searchHistoryItem)
      : searchHistoryItem
  )
